import { ValidationError, ValidationResult } from '@/types/validationTypes'

export const validateEmail = (email: string): string | null => {
  if (!email.trim()) {
    return 'Email is required'
  }
  if (email.length > 255) {
    return 'Email must be 255 characters or less'
  }
  const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/
  if (!emailRegex.test(email)) {
    return 'Please enter a valid email address'
  }
  return null
}

export const validatePassword = (password: string): string | null => {
  if (!password) {
    return 'Password is required'
  }
  if (password.length < 8) {
    return 'Password must be at least 8 characters long'
  }
  if (!/[a-zA-Z]/.test(password)) {
    return 'Password must contain at least one letter'
  }
  if (!/[0-9]/.test(password)) {
    return 'Password must contain at least one number'
  }
  return null
}

export const validateName = (name: string): string | null => {
  if (!name.trim()) {
    return 'Name is required'
  }
  if (name.trim().length < 2) {
    return 'Name must be at least 2 characters long'
  }
  if (name.length > 50) {
    return 'Name must be 50 characters or less'
  }
  const nameRegex = /^[a-zA-Z0-9\s-]+$/
  if (!nameRegex.test(name)) {
    return 'Name can only contain letters, numbers, spaces, and hyphens'
  }
  return null
}

export const validateSubject = (subject: string): string | null => {
  if (!subject.trim()) {
    return 'Subject is required'
  }
  if (subject.trim().length < 2) {
    return 'Subject must be at least 2 characters long'
  }
  if (subject.length > 100) {
    return 'Subject must be 100 characters or less'
  }
  return null
}

export const validateMessage = (message: string): string | null => {
  if (!message.trim()) {
    return 'Message is required'
  }
  if (message.trim().length < 10) {
    return 'Message must be at least 10 characters long'
  }
  if (message.length > 1000) {
    return 'Message must be 1000 characters or less'
  }
  return null
}

export const sanitizeInput = (input: string): string => {
  return input
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')
    .replace(/"/g, '&quot;')
    .replace(/'/g, '&#x27;')
    .replace(/\//g, '&#x2F;')
}

export const validateForm = (
  fields: Record<string, string>,
  rules: Record<string, (value: string) => string | null>
): ValidationResult => {
  const errors: ValidationError[] = []

  for (const [field, value] of Object.entries(fields)) {
    const rule = rules[field]
    if (rule) {
      const error = rule(value)
      if (error) {
        errors.push({ field, message: error })
      }
    }
  }

  return {
    isValid: errors.length === 0,
    errors,
  }
}

export const getFieldError = (
  errors: ValidationError[],
  fieldName: string
): string | undefined => {
  return errors.find((error) => error.field === fieldName)?.message
}
